module.exports = __webpack_public_path__ + "static/media/lions.faf05859.webp";